export const objectToQueryString = (params: Record<string, any>): string => {
  const strParams: string[] = [];
  Object.keys(params).forEach((key) => {
    if (params[key]) {
      strParams.push(`${key}=${params[key]}`);
    }
  });
  return strParams.join('&');
};

export const isExternalLink = (url: string): boolean => {
  const isExternal = url.includes('http://') || url.includes('https://');
  return isExternal;
};
